'use strict';

var tslib = require('tslib');
var React = require('react');
var utils = require('./utils-eb39d0ac.js');
var definitions = require('./definitions-4ae1604d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var directionToMargin = {
    x: 'margin-left',
    y: 'margin-top',
};
var marginGap = styled.css(function (p) { return styled.css(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n    && > *:not(:first-child) {\n      ", ": ", ";\n    }\n  "], ["\n    && > *:not(:first-child) {\n      ", ": ", ";\n    }\n  "])), directionToMargin[p.$direction], p.$gap); });
var gap = styled.css(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  gap: ", ";\n"], ["\n  gap: ", ";\n"])), function (p) { return p.$gap; });
var equallySizedChildren = styled.css(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  && > * {\n    flex: 1 0 0%;\n  }\n"], ["\n  && > * {\n    flex: 1 0 0%;\n  }\n"])));
var StyledList = styled__default["default"].div.withConfig({ displayName: "StyledList", componentId: "-1047oxz" })(function (p) { return styled.css(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n    display: flex;\n    flex-direction: ", ";\n    flex: 1 1 auto;\n\n    ", ";\n    ", ";\n  "], ["\n    display: flex;\n    flex-direction: ", ";\n    flex: 1 1 auto;\n\n    ", ";\n    ", ";\n  "])), p.$direction === definitions.Axis.Y ? 'column' : 'row', p.$isGapSupported ? gap : marginGap, p.$equallySizedChildren && equallySizedChildren); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var renderChildren = function (_a, children) {
    var direction = _a.direction, separator = _a.separator;
    if (!React__default["default"].isValidElement(separator)) {
        return children;
    }
    var renderedChildren = [];
    React__default["default"].Children.forEach(children, function (child, idx) {
        if (child === null || child === undefined) {
            return;
        }
        if (idx !== 0) {
            var separatorKey = "separator-".concat(idx);
            renderedChildren.push(React__default["default"].cloneElement(separator, {
                direction: direction,
                key: separatorKey,
                role: 'presentation',
            }));
        }
        renderedChildren.push(child);
    });
    return renderedChildren;
};
var isGapSupported = utils.isFlexGapSupported();
/**
 * Layout component that lays its children out in a line, either horizontally or vertically.
 */
function List(_a) {
    var _b = _a.container, container = _b === void 0 ? 'div' : _b, _c = _a.direction, direction = _c === void 0 ? definitions.Axis.X : _c, _d = _a.gap, gap = _d === void 0 ? 0 : _d, _e = _a.gapUnit, gapUnit = _e === void 0 ? definitions.LengthUnit.Rem : _e, _f = _a.equallySizedChildren, equallySizedChildren = _f === void 0 ? false : _f, children = _a.children, containerProps = _a.containerProps, className = _a.className, variant = _a.variant, separator = _a.separator, style = _a.style;
    var props = { className: className, variant: variant, separator: separator, direction: direction };
    return (React__default["default"].createElement(StyledList, tslib.__assign({}, containerProps, { as: container, className: className, style: style, "$direction": direction, "$equallySizedChildren": equallySizedChildren, "$gap": gap > 0 ? "".concat(gap).concat(gapUnit) : undefined, "$isGapSupported": isGapSupported }), renderChildren(props, children)));
}

exports.List = List;
//# sourceMappingURL=index-105ce710.js.map
